// import { OscEnvironment } from 'osc-utils';
import { OscEnvironment } from 'src/app/osc-utils/enums/osc-environments';
import { environment } from 'src/environments/environment';

export function getEnvironment(): OscEnvironment {
  return OscEnvironment[environment.name];
}
